import React from "react";
function Loder() {
    return (
        <div class="spinner-border text-danger loder" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    );
};
export default Loder;